import { z } from "zod";
export const TOKEN_KIND_USER = "user";
export const TOKEN_KIND_MACHINE = "machine";
export const userTokenClaimsSchema = z
    .object({
    sub: z.string().min(1),
    kind: z.literal(TOKEN_KIND_USER),
})
    .passthrough();
export const machineTokenClaimsSchema = z
    .object({
    sub: z.string().min(1),
    kind: z.literal(TOKEN_KIND_MACHINE),
    machine_id: z.string().min(1),
})
    .passthrough();
export const authTokenClaimsSchema = z.discriminatedUnion("kind", [
    userTokenClaimsSchema,
    machineTokenClaimsSchema,
]);
export function isUserTokenClaims(claims) {
    return claims.kind === TOKEN_KIND_USER;
}
export function isMachineTokenClaims(claims) {
    return (claims.kind === TOKEN_KIND_MACHINE && typeof claims.machine_id === "string");
}
export function parseAuthTokenClaims(claims) {
    return authTokenClaimsSchema.parse(claims);
}
export const signupInputSchema = z.object({
    email: z.string().email(),
    password: z.string().min(8).max(128),
    name: z.string().min(1).max(128).optional(),
});
export const loginInputSchema = z.object({
    email: z.string().email(),
    password: z.string().min(1),
});
export const changePasswordInputSchema = z.object({
    current_password: z.string().min(1),
    new_password: z.string().min(8).max(128),
});
export const machineLinkBodySchema = z.object({
    machine_id: z.string().uuid(),
});
export const machineLinkQuerySchema = z.object({
    machine_id: z.string().uuid(),
});
export const authErrorBodySchema = z.object({
    error: z.string(),
    message: z.string().optional(),
    details: z.unknown().optional(),
});
export class AuthApiError extends Error {
    status;
    code;
    details;
    /**
     * How long the server asked the caller to wait, from Retry-After, when it
     * sent one. Read by auth-react to schedule a retry instead of signing the
     * person out (ONL-243).
     */
    retryAfterMs;
    constructor(status, code, message, details, retryAfterMs) {
        super(message);
        this.name = "AuthApiError";
        this.status = status;
        this.code = code;
        this.details = details;
        this.retryAfterMs = retryAfterMs;
    }
}
